import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { map, isNil, isEmpty } from "ramda";
import moment from "moment";

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  paper: {
    padding: "6px",
    textAlign: "center",
    color: theme.palette.text.secondary,
    fontSize: "11pt",
    borderRadius: "0px"
  }
});

const duration = rental => {
  let days = moment(rental.date2).diff(rental.date1, "days");
  if (rental.time1 === "10:00:00" && rental.time2 === "18:00:00") {
    days += 1;
  } else if (rental.time1 === "18:00:00" && rental.time2 === "10:00:00") {
    days -= 1;
  }
  return days;
};

let recorrido = 0; let item = 0; let CountData = 0

function RenderRow(event, classes) {
  //console.log(event);
  if (isNil(event)) {
    return <React.Fragment key={`fr_${event.key}`} />;
  } else {
    return (
      <React.Fragment key={`fr_${event.key}`}>
        <Grid container item xs={12} spacing={0} key={`r_${event.key}`}>
          <Grid item xs={2} key={`c1_${event.key}`}>
            <Paper
              className={classes.paper}
              style={{ backgroundColor: event.bgColor, borderRadius: "0px" }}
            >
              {event.description}
            </Paper>
          </Grid>
          <Grid item xs={2} key={`c2_${event.key}`}>
            <Paper
              className={classes.paper}
              style={{ backgroundColor: event.bgColor }}
            >
              {event.title}
            </Paper>
          </Grid>
          <Grid item xs={2} key={`c3_${event.key}`}>
            <Paper
              className={classes.paper}
              style={{ backgroundColor: event.bgColor }}
            >
              {moment(event.date1).format("DD-MM-YYYY")}
            </Paper>
          </Grid>
          <Grid item xs={2} key={`c4_${event.key}`}>
            <Paper
              className={classes.paper}
              style={{ backgroundColor: event.bgColor }}
            >
              {moment(event.date2).format("DD-MM-YYYY")}
            </Paper>
          </Grid>
          <Grid item xs={1} key={`c5_${event.key}`}>
            <Paper
              className={classes.paper}
              style={{ backgroundColor: event.bgColor }}
            >
              {!isEmpty(event.time1) &&
                !isEmpty(event.time2) &&
                `${duration(event)} days`}{" "}
              {isEmpty(event.time1) && isEmpty(event.time2) && "0 days"}
              {/* {moment(event.date2).diff(event.date1, "days")} days */}
            </Paper>
          </Grid>
          <Grid item xs={1} key={`c8_${event.key}`}>
            <Paper
              className={classes.paper}
              style={{ backgroundColor: event.bgColor }}>
              {!isEmpty(event.time1) && !isEmpty(event.time2) && `${event.km} km`}
              {isEmpty(event.time1) && isEmpty(event.time2) && `${event.km} km`}
            </Paper>
          </Grid>
          <Grid item xs={1} key={`c6_${event.key}`}>
            <Paper
              className={classes.paper}
              style={{ backgroundColor: event.bgColor }}
            >
              {event.location1 ? event.location1 : "n/a"}
            </Paper>
          </Grid>
          <Grid item xs={1} key={`c7_${event.key}`}>
            <Paper
              className={classes.paper}
              style={{ backgroundColor: event.bgColor2 }}
            >
              {event.location2 ? event.location2 : "n/a"}
            </Paper>
          </Grid>

        </Grid>
      </React.Fragment>
    );
  }
}

function NestedGrid(props) {
  const { classes, events } = props;
  //console.log(events)
  CountData = events.length
  //console.log(CountData)
  let kmNew = 0, recorrido1 = 0
  for (let index = 0; index < events.length; index++) {
    const element = events[index]; // elemento actual
    let days = duration(element) // dias del evento actual
    if (!isEmpty(element.time1) && !isEmpty(element.time2)) {
      recorrido1 = recorrido1 + (days * 300)
      element.km = element.km + recorrido1
      //console.log('kmNew' + recorrido1)
    }
    else {
      element.km = element.km + recorrido1
      //console.log('kmNew2' + recorrido1)
    }
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        {map(event => {
          return RenderRow(event, classes);
        }, events)}
      </Grid>
    </div>
  );
}

NestedGrid.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(NestedGrid);



// WEBPACK FOOTER //
// ./src/components/listBikeHistoryGrid.js